import React, { useState, useEffect } from "react"
import { useParams } from 'react-router-dom'
import PlotData from '../../components/plots/PlotData'
import NavbarBoot from '../../components/nav/NavbarNew'
import DatePicker from "react-datepicker"
import moment from "moment"
import "react-datepicker/dist/react-datepicker.css"
import GraphData from "../../components/plots/PlotData" // Update the import


function PlotSurf2wk() {
  const { duration } = useParams();
  const today = new Date();
  const start = new Date();

  let days = 14;
  if (duration != null) {
    days = parseInt(duration, 10);
  }
  start.setDate(today.getDate() - days);

  const [tempDateRange, setTempDateRange] = useState({
    from_date: moment(start).format("YYYY-MM-DD"),
    to_date: moment(today).format("YYYY-MM-DD"),
  });

  const [dateRange, setDateRange] = useState({ ...tempDateRange });

  useEffect(() => {
    setDateRange({ ...tempDateRange });
  }, [tempDateRange]);

  const handleStartDateChange = (date) => {
    setTempDateRange({
      ...tempDateRange,
      from_date: date ? moment(date).format("YYYY-MM-DD") : tempDateRange.from_date,
    });
  };

  const handleEndDateChange = (date) => {
    setTempDateRange({
      ...tempDateRange,
      to_date: date ? moment(date).format("YYYY-MM-DD") : tempDateRange.to_date,
    });
  };

  const handleDateUpdate = () => {
    const daysDifference = moment(tempDateRange.to_date).diff(
      moment(tempDateRange.from_date),
      "days"
    );
    if (daysDifference >= 0 && daysDifference <= 21) {
      setDateRange(tempDateRange);
    } else {
      alert("Please select a date range not exceeding 21 days.");
    }
  };

  const start_time = dateRange.from_date + " 00:00:00";
  const end_time = dateRange.to_date + " 00:00:00";

  return (
    <>
      <NavbarBoot />
      <div>
        <div>
          <h2 className="bg-slate-300 text-2xl pl-5">WMATA B-Line</h2>
          <h6 className="bg-slate-300 text-xs pl-5">Temperature & Humidity</h6>
          <div className="date-picker-container">
            <DatePicker
              selected={new Date(tempDateRange.from_date)}
              onChange={handleStartDateChange}
              maxDate={new Date()}
            />
            <DatePicker
              selected={new Date(tempDateRange.to_date)}
              onChange={handleEndDateChange}
              maxDate={new Date()}
            />
            <button onClick={handleDateUpdate}>Update Date Range</button>
          </div>
      <h2 className='bg-slate-300 text-2xl pl-5'>WMATA Tunnels</h2>
      <h6 className='bg-slate-300 text-xs pl-5 pb-2'>Surface Temperature & Humidity</h6>

      <PlotData
        url='/api/wmata/gage/'
        gagelist={{
          primary: [
            {
              location: 'B-1_525.50',
              name: 'B-1_525.50 Air',
              sensortype: 'temperature',
              table: "leap_th1_location"
            },
            {
                location: 'B-1_525.50',
                name: 'B-1_525.50 Surface',
                sensortype: 'surf_temperture',
                table: "leap_th1_location"
              },
            {
              location: 'B-2_525.50',
              name: 'B-2_525.50 Air',
              sensortype: 'temperature',
              table: "leap_th1_location"
            },
            {
                location: 'B-2_525.50',
                name: 'B-2_525.50 Surface',
                sensortype: 'surf_temperture',
                table: "leap_th1_location"
              },
            
              {
                location: "temp",
                name: "DCA temp",
                sensortype: "temp",
                table: "weather",
              },

          ],
          secondary: [
            {
              location: 'prcp',
              name: 'Prcp',
              sensortype: 'prcp',
              table: "weather"
            },],

          y_range: [0, 70],
          title: 'B-Line Surface Temperatures',
        }}
        dateRange={{ dateRange: [start_time, end_time] }}
        config={{
          y_axes_range: [0.0, 100],
          y_axes_range2: [0.0, 2.0],
          y_axis_label: 'Temperature (&#176;F)',
          y_axis_label2: 'Precipitation (in.)',
        }}
      />
      <PlotData
        url='/api/wmata/gage/'
        gagelist={{
          primary: [
            {
              location: 'A-2_292.50',
              name: 'A-2_292.50 Air',
              sensortype: 'temperature',
              table: "leap_th1_location"
            },
            {
                location: 'A-2_292.50',
                name: 'A-2_292.50 Surface',
                sensortype: 'surf_temperture',
                table: "leap_th1_location"
              },

            
              {
                location: "temp",
                name: "DCA temp",
                sensortype: "temp",
                table: "weather",
              },

          ],
          secondary: [
            {
              location: 'prcp',
              name: 'Prcp',
              sensortype: 'prcp',
              table: "weather"
            },],

          y_range: [0, 70],
          title: 'A-Line Surface Temperatures',
        }}
        dateRange={{ dateRange: [start_time, end_time] }}
        config={{
          y_axes_range: [0.0, 100],
          y_axes_range2: [0.0, 2.0],
          y_axis_label: 'Temperature (&#176;F)',
          y_axis_label2: 'Precipitation (in.)',
        }}
      />
      <h6 className='bg-slate-300 text-xs pl-5 pb-2'>Dew Point vs Temperature & Humidity</h6>

      <PlotData
        url='/api/wmata/gage/'
        gagelist={{
          primary: [
            {
              location: 'B-1_525.50',
              name: 'B-1_525.50 DewPt',
              sensortype: 'dewpt',
              table: "leap_th1_location"
            },
            {
                location: 'B-1_525.50',
                name: 'B-1_525.50 Surface',
                sensortype: 'surf_temperture',
                table: "leap_th1_location"
              },
            {
              location: 'B-2_525.50',
              name: 'B-2_525.50 DewPt',
              sensortype: 'dewpt',
              table: "leap_th1_location"
            },
            {
                location: 'B-2_525.50',
                name: 'B-2_525.50 Surface',
                sensortype: 'surf_temperture',
                table: "leap_th1_location"
              },
            


          ],
          secondary: [
            {
              location: 'prcp',
              name: 'Prcp',
              sensortype: 'prcp',
              table: "weather"
            },],

          y_range: [0, 70],
          title: 'B-Line Dew Pt & Surface Temps',
        }}
        dateRange={{ dateRange: [start_time, end_time] }}
        config={{
          y_axes_range: [0.0, 100],
          y_axes_range2: [0.0, 2.0],
          y_axis_label: 'Temperature (&#176;F)',
          y_axis_label2: 'Precipitation (in.)',
        }}
      />




    </div>
    
    </div></>
  )
}

export default PlotSurf2wk
